import { render, staticRenderFns } from "./GerarNovaSenha.vue?vue&type=template&id=32e1df2b"
import script from "./GerarNovaSenha.vue?vue&type=script&lang=js"
export * from "./GerarNovaSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports